import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsPlanYourVisitViewedParams = {
  filter_term_displayed?: boolean;
  trail_id?: string;
};

/**
 * User views the plan your visit section of the trail page. This event should only fire when the user sees 100% of the plan your visit section. When a user reaches a trail page via a filtering function, that term should display at the top of the default tags list.
 * @param params - Attributes to log with the amplitude event
 * @param params.filter_term_displayed - TRUE if the user sees a filtered function term displayed at the top of the default tags list
 * @param params.trail_id - Trail page user was on when they viewed the plan your visit section of the trail page.
 */
const logTrailDetailsPlanYourVisitViewed = ({ filter_term_displayed, trail_id }: logTrailDetailsPlanYourVisitViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'trail details plan your visit viewed',
    { 'filter term displayed': filter_term_displayed, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsPlanYourVisitViewed;
